import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { searchService } from '../../services';

function SearchResults() {
  const [results, setResults] = useState([]);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const customerName = params.get('customer_name');
  const customerNumber = params.get('customer_number');
  const ticketNumber = params.get('ticket_number');
  const navigate = useNavigate();

  const handleGoToTicket = id => {
    navigate(`/smart-ticket/${id}`);
  };

  // Build search criteria display
  const getSearchCriteria = () => {
    const criteria = [];
    if (customerName) criteria.push(`Customer Name: "${customerName}"`);
    if (customerNumber) criteria.push(`Customer Number: "${customerNumber}"`);
    if (ticketNumber) criteria.push(`Ticket Number: "${ticketNumber}"`);
    return criteria.join(', ');
  };

  useEffect(() => {
    const fetchResults = async () => {
      try {
        const data = await searchService.fetchSearchResults(customerName, customerNumber, ticketNumber);
        setResults(data);
      } catch (error) {
        console.error('Error al buscar:', error);
      }
    };

    fetchResults();
  }, [customerName, customerNumber, ticketNumber]);

  return (
    <div className="bg-slate-100 h-full flex flex-col items-center justify-start py-8">
      <div className="w-3/5">
        <h1 className="text-red-800 text-5xl font-semibold mb-4 text-left">
          Search Results
        </h1>
        <p className="text-gray-600 text-lg mb-2">
          Searching for: <span className="font-semibold">{getSearchCriteria()}</span>
        </p>
      </div>

      <div className="border-t border-red-600 w-3/5 font-rubik">
        {results.length > 0 ? (
          results.map((item, index) => (
            <div
              key={index}
              className="w-full p-4 rounded-xl flex flex-col mt-4 bg-white shadow-slate-300 border-[0.5vmin] shadow-[4px_4px_0px_0px_#05060f]"
            >
              <h1 className="font-semibold text-gray-700 text-2xl border-b border-black pb-2 uppercase">
                Ticket #
                <span className="font-normal text-red-900 pl-2">
                  {item.ticket_number}
                </span>
              </h1>

              <div className="text-lg border-b border-black pb-2">
                <p className="text-gray-600 pb-2">
                  Customer Name: <strong>{item.customer_name}</strong>
                </p>
                <p className="text-gray-600 pb-2">
                  Customer Number: <strong>{item.customer_number}</strong>
                </p>
                <p className="text-gray-600 pb-2">
                  Issue With: <strong>{item.issue_with}</strong>
                </p>
              </div>

              <button
                onClick={() => handleGoToTicket(item.id)}
                className="px-8 py-2 mt-2 ml-auto bg-slate-600 text-white font-semibold border-b-4 rounded hover:bg-green-500 border-slate-800 hover:border-green-700 flex items-center"
              >
                Go to ticket
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  className="size-5"
                >
                  <path
                    fillRule="evenodd"
                    d="M5.22 14.78a.75.75 0 0 0 1.06 0l7.22-7.22v5.69a.75.75 0 0 0 1.5 0v-7.5a.75.75 0 0 0-.75-.75h-7.5a.75.75 0 0 0 0 1.5h5.69l-7.22 7.22a.75.75 0 0 0 0 1.06Z"
                    clipRule="evenodd"
                  />
                </svg>
              </button>
            </div>
          ))
        ) : (
          <p className="text-gray-500 text-center py-4">
            No results found for: {getSearchCriteria()}
          </p>
        )}
      </div>
    </div>
  );
}

export default SearchResults;
